import React, { useState } from "react";
import { useEffect } from "react";
import { Typography, Avatar, Divider, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "src/Assets/css/home/post.module.css";
import crown from "src/Assets/images/crown.png";
import silvercrown from "src/Assets/images/silvercrown.png";
import API from "../../../network";
import AvatarBadge from "src/Components/AvatarBadge";
import location from "src/Assets/images/locationpinchildpost.png";
import dot from "src/Assets/images/dot.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArchivedBlogs from "./ArchivedBlogs";

const Container = styled("div")({
  backgroundColor: "#fff",
  margin: "20px",
  borderRadius: "20px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  boxSizing: "border-box",

  // for chrome and safari
  "&::-webkit-scrollbar": {
    width: "0",
    background: "transparent",
  },

  // Firefox
  scrollbarWidth: "none", // Remove scrollbar width for Firefox
});

const Status = styled("div")({
  width: "15px",
  height: "15px",
  borderRadius: "15px",
  alignSelf: "flex-end",
  marginBottom: "6px",
  cursor: "pointer",
});

const UserName = styled(Typography)({
  fontSize: "14px",
  fontWeight: "700",
  color: "#333",
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

const MessageTime = styled(Typography)({
  fontSize: "12px",
  color: "#878585",
});

const NameContainer = styled("div")({
  flex: 1,
  flexDirection: "column",
  display: "flex",
  marginLeft: "8px",
  minWidth: 0,
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

function ActivityLog(props) {
  const [activityLogData, setActivityLogData] = useState([]);
  const [isActivityLogLoading, setIsActivityLogLoading] = useState(true);
  const [archivedBlogs, setArchivedBlogs] = useState([]);

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  useEffect(() => {
    const fetchActivityLogData = async () => {
      setIsActivityLogLoading(true);

      try {
        // Fetch archived blogs
        if (props.type === "archived") {
          setActivityLogData([]);
          setArchivedBlogs([]);
          const formData = new FormData();
          formData.append("tenantid", props.tenantId);

          const response = await API.fetchArchivedBlogs(formData);

          setArchivedBlogs(response?.data?.CommunityBlogs || []);
          return;
        }

        if (props.type === "impactful") {
          const response = await API.getImpactfullMemberActivityLog(
            props.tenantId,
          );

          console.log("Impactful Member Activity Log:", response?.data);

          if (response?.data?.impactfulMembersActionList) {
            setActivityLogData(response.data.impactfulMembersActionList);
          } else {
            setActivityLogData([]);
          }

          return;
        }

        // Fetch activity log data

        setActivityLogData([]);
        setArchivedBlogs([]);

        const response = await API.fetchActivityLogData(
          props.tenantId,
          props.type,
        );
        setActivityLogData(response.data.messageList);
      } catch (e) {
        console.error("Failed to fetch activity log data:", e);
      } finally {
        setIsActivityLogLoading(false);
      }
    };

    if (props.tenantId && props.type) {
      fetchActivityLogData();
    }
  }, [props.type, props.tenantId]);

  const currStatus = (status) => {
    console.log(`status: ${status}`);
    switch (status) {
      case "Y":
        return "Approved";
      case "NA":
        return "Rejected";
      case "1":
        return "Approved";
      case "0":
        return "Rejected";
      case "A":
        return "Approved";
      case "I":
        return "Rejected";
      case "dismiss":
        return "Dismissed";
      case "approve":
        return "Approved";
      default:
        return "";
    }
  };

  const getTooltipText = (status) => {
    switch (status) {
      case "Open ASK":
      case "OpenASK":
      case "ASK":
      case "A":
        return "ASK";
      case "SAY":
      case "OpenSAY":
      case "S":
        return "SAY";
      case "Important Update":
      case "UPDATE":
      case "impupdate":
      case "I":
        return "UPDATE";
      case "#tag":
      case "#TAG":
      case "hashTAG":
      case "H":
      case "X":
        return "TAG";
      default:
        return "";
    }
  };

  const isActive = (status) => {
    switch (status) {
      case "Open ASK":
      case "OpenASK":
      case "ASK":
      case "A":
        return "#2168b2";
      case "SAY":
      case "OpenSAY":
      case "S":
        return "#45a735";
      case "Important Update":
      case "UPDATE":
      case "impupdate":
      case "I":
        return "#e82727";
      case "#tag":
      case "#TAG":
      case "hashTAG":
      case "H":
      case "X":
        return "#efba29";
      default:
        return "transparent";
    }
  };

  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  }

  const { type } = props;

  if (isActivityLogLoading) {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <CircularProgress size={30} />
      </div>
    );
  }

  if (type === "archived") {
    return (
      <ArchivedBlogs
        archivedBlogs={archivedBlogs}
        setArchivedBlogs={setArchivedBlogs}
      />
    );
  }

  if (activityLogData.length < 1) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        No data found !
      </div>
    );
  }

  console.log(`type:`, type);

  return (
    <>
      {activityLogData.map((item) => (
        <Container style={{}} key={`key-id-${item?.id}`}>
          <div style={{ display: "flex" }}>
            <AvatarBadge
              src={`${profileImagePath}${
                type === "report"
                  ? item?.rpt_created_image_s
                  : type === "message"
                    ? item?.msg_usr_image_s
                    : type === "block"
                      ? item?.blk_image
                      : type === "impactful"
                        ? item?.uimage
                        : item?.image
              }`}
              className={styles.avatar}
              variant="square"
              isPrimaryModerator={
                type == "moderator" ? item.is_primary_moderator == 1 : false
              }
              isModerator={
                type == "moderator"
                  ? item.moderator_status == 1 && item.is_primary_moderator == 0
                  : false
              }
            />
            <NameContainer>
              <UserName>
                {type === "report"
                  ? item?.rpt_created_display_name_s
                  : type === "message"
                    ? item?.msg_usr_display_name_s
                    : type === "block"
                      ? item?.blk_display_name
                      : type === "impactful"
                        ? item?.userDisplayName
                        : item?.display_name}
              </UserName>
              <div style={{ display: "flex", alignItems: "center" }}>
                <MessageTime>
                  {type == "report"
                    ? item?.rpt_created_date_dt
                    : type === "message"
                      ? item?.msg_created_date_dt
                      : type === "block"
                        ? item?.blk_updated_date
                        : type === "impactful"
                          ? item?.created_date
                          : item?.created_date}
                </MessageTime>
                {(item?.msg_loc_name_s || item?.rpt_loc_name_s) && (
                  <>
                    <img style={{ marginLeft: "3px" }} src={dot} alt="dot" />
                    <img
                      src={location}
                      style={{ width: 8, marginLeft: 7, marginRight: "3px" }}
                      alt="location"
                    />
                    <MessageTime>
                      {item?.msg_loc_name_s || item?.rpt_loc_name_s}
                    </MessageTime>
                  </>
                )}
              </div>
            </NameContainer>
            {type === "report" && item.rpt_reason_s && (
              <div style={{ fontSize: "12px" }}>
                Reported by <b>{item.rpt_display_name_s}</b> as{" "}
                <b>{truncateText(item.rpt_reason_s, 50)}</b>
              </div>
            )}
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              color: "#333",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "pre-wrap",
              maxWidth: "100%",
            }}
          >
            {type == "report" ? (
              item.rpt_message_text_s
            ) : type === "block" ? (
              <p
                style={{
                  color: "#333",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  maxWidth: "100%",
                }}
              >
                Message: Request you to Unblock access to{" "}
                {item?.blk_tenant_name}
              </p>
            ) : (
              item.msg_message_text_s
            )}
          </div>
          {type != "moderator" ? (
            <Tooltip
              title={getTooltipText(
                type === "report"
                  ? item.rpt_message_type_s
                  : item.msg_message_type_s,
              )}
              arrow
            >
              <Status
                style={{
                  backgroundColor: isActive(
                    type === "report"
                      ? item.rpt_message_type_s
                      : item.msg_message_type_s,
                  ),
                }}
              />
            </Tooltip>
          ) : (
            <img
              src={silvercrown}
              height="16px"
              width="20px"
              alt=""
              style={{
                marginLeft: "auto",
                marginBottom: "5px",
                marginRight: "6px",
              }}
            />
          )}
          <Divider variant="fullWidth" />
          <div style={{ marginTop: "10px", fontSize: "14px" }}>
            <b>
              {type === "report"
                ? item.rpt_message_type_s
                : type === "message"
                  ? item.msg_message_type_s
                  : type === "block"
                    ? "Request to Unblock"
                    : type === "impactful" && item?.NominatedStatus === "remove"
                      ? "Removed as Impactful Member"
                      : type === "impactful"
                        ? "Impactful Member Nomination"
                        : "Moderator Request"}
            </b>{" "}
            {item?.NominatedStatus !== "remove" && <span>was</span>}{" "}
            <b>
              {currStatus(
                type === "report"
                  ? item.rpt_admin_status_s
                  : type === "message"
                    ? item.msg_message_status_s
                    : type === "block"
                      ? item?.blk_follow_status
                      : type === "impactful"
                        ? item?.NominatedStatus
                        : item.moderator_status,
              )}
            </b>{" "}
            {type === "report"
              ? item.rpt_action_on_time_dt
              : type === "message"
                ? item.msg_action_on_time_dt
                : type === "block"
                  ? item?.blk_created_date
                  : type === "impactful"
                    ? item?.updated_date
                    : item.action_on_time}{" "}
            ago by{" "}
            <b>
              {type === "report"
                ? item.rpt_a_display_name_s
                : type === "message"
                  ? item.msg_a_display_name_s
                  : type === "block"
                    ? item?.blk_action_by_display_name
                    : type === "impactful"
                      ? item?.ActionByUserDisplayName
                      : item.action_by_display_name}
            </b>
          </div>
        </Container>
      ))}
    </>
  );
}
export default ActivityLog;
